<script setup lang="ts">
import type {Component} from "vue";
import IconArrowLg from "~/components/sx/icons/IconArrowLg.vue";

const { t } = useLocale();
const { locale: localeI18n } = useI18n();

interface IProps {
  logo: Component,
  title: string,
  description: string,
  id: number,
}

defineProps<{ item: IProps }>();
</script>

<template>
  <RouterLink v-if="item?.id" :to="`/${localeI18n}/faq/${item?.id}`" class="faq-article">
    <div class="faq-article__inner">
      <div class="faq-article__content">
        <div class="faq-article__logo">
          <Component :is="item.logo" />
        </div>
        <div class="faq-article__info">
          <h3 class="faq-article__title">
            {{ t(item.title) }}
          </h3>
          <p class="faq-article__description">
            {{ t(item.description) }}
          </p>
        </div>
      </div>
      <div class="faq-article__icon-arrow">
        <IconArrowLg />
      </div>
    </div>
  </RouterLink>
</template>

<style scoped lang="scss">
.faq-article {
  padding: 24px 16px;
  text-align: start;
  cursor: pointer;
  transition: .3s;
  outline-color: black;
  border: 1px solid transparent;
  border-bottom: var(--border-sx-main);
  &:hover {
    border-radius: 8px;
    border: var(--border-sx-contrast);
  }
  @media (max-width: 599px) {
    padding: 12px 8px;
  }
  &__inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    @media (max-width: 599px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }
  }
  &__content {
    display: flex;
    align-items: center;
    gap: 24px;
    @media (max-width: 599px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }
  }
  &__info {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  &__title {
    font-weight: 500;
    font-size: 24px;
    line-height: 28px;
    letter-spacing: 0;
    color: var(--font-sx-color-black)
  }
  &__description {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0;
    color: var(--font-sx-color-lightgray)
  }
}
</style>